import { render, staticRenderFns } from "./PruningTable.vue?vue&type=template&id=54e88d11&scoped=true&lang=html&"
import script from "./PruningTable.vue?vue&type=script&lang=js&"
export * from "./PruningTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e88d11",
  null
  
)

export default component.exports